"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsLoader = void 0;
var preview_products_loader_component_1 = require("./preview-products-loader.component");
Object.defineProperty(exports, "PreviewProductsLoader", { enumerable: true, get: function () { return preview_products_loader_component_1.PreviewProductsLoader; } });
